export default __webpack_public_path__ + "static/media/CoreUI-Icons-Brand.42233038.woff";